import React from 'react';
import CommunicationTypeModel from '../../../../model/CommunicationType';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
const CommunicationType = ({ ...rest }) => {
    const t = useT();
    const { options } = useEnumerableModel(CommunicationTypeModel);
    return (<MultiselectFilter {...rest} itemId={itemIdValue} options={options} title={t('Communication type')}/>);
};
export default CommunicationType;
